import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoTrim: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideoTrim"><Path fillRule="evenodd" clipRule="evenodd" d="M16 22H14V20H2V4H14V2H16V22ZM7 8.5V15.5L11.6667 12L7 8.5Z" fill="currentColor"/><Path d="M18 4H22V20H18V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoTrim;
